module.exports = __webpack_public_path__ + "static/img/ask-question.56e56df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ask-question.png
// module id = HjVB
// module chunks = 34